import { useRegisterSW } from "virtual:pwa-register/react";
import { useTranslation } from "react-i18next";

export function PwaUpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      if (registration) {
        setInterval(
          () => {
            registration.update();
          },
          60 * 60 * 1000,
        );
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-4 start-4 z-50 flex items-center gap-3 rounded-xl border border-border bg-card p-4 shadow-lg">
      <p className="text-sm text-foreground">
        {t("common.newVersionAvailable", "גרסה חדשה זמינה")}
      </p>
      <button
        type="button"
        onClick={() => updateServiceWorker(true)}
        className="rounded-lg bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        {t("common.update", "עדכון")}
      </button>
      <button
        type="button"
        onClick={() => setNeedRefresh(false)}
        className="text-sm text-muted-foreground hover:text-foreground"
      >
        {t("common.close")}
      </button>
    </div>
  );
}
